import React from 'react'
import styled from 'styled-components'
import { numberFormat, estimate } from 'estimate_list/libs/util'
import { useDispatch, useSelector } from 'react-redux'
import { setCompareItems, setCompareViewModal } from 'estimate_list/libs/action'

const ItemComparison = ({ data, comparisonStyle }) => {
    const dispatch = useDispatch()
    const { compareItems } = useSelector((state) => state.estimateAdd)
    const { lists } = useSelector((state) => state.initial)

    const addCompareItems = () => {
        const itemId = data.item_id
        const compareData =
            data.item_id +
            '^' +
            data.full_item_name +
            '^' +
            numberFormat(data.price_low_cash) +
            '^' +
            data.cate2_name +
            '^' +
            data.cate_id +
            '^' +
            data.zzim_my +
            '^' +
            data.cntZzim

        const compareItemsData = estimate.addCompareItems(itemId, compareData)
        dispatch(setCompareItems(compareItemsData))
    }

    const handleOpenModal = () => {
        dispatch(setCompareViewModal(true))
    }

    const compareChecked = () => {
        if (compareItems === undefined) return
        let pos = compareItems
            .map(function (e) {
                return e[0].toString()
            })
            .indexOf(data.item_id.toString())
        let compareChecked = pos !== -1 ? true : false
        return compareChecked
    }

    return (
        lists.itemList?.isCompare === 1 && ( // 1: 상품비교 가능, 0: 상품비교 불가능
            <Style className="button" comparisonStyle={comparisonStyle}>
                <div className={`check ${compareChecked() ? 'active' : ''}`} onClick={compareItems.length < 10 ? addCompareItems : handleOpenModal} />
                <span className="txt">상품비교</span>
            </Style>
        )
    )
}

const Style = styled.button`

    &.button {
        ${props => props.comparisonStyle
            ? props.comparisonStyle.buttonStyle
            :
            `position: absolute;
            top: 0;
            left: calc(100% - 29px);
            display: flex;
            white-space: nowrap;
            padding: 0 0 0 9px;
            margin: 0 0 0 1px;
            height: 38px;
            align-items: center;
            border: 1px solid transparent;
            z-index: 1;`
        }
        .check {
            width: ${props => props.comparisonStyle?.checkBoxStyle ? props.comparisonStyle.checkBoxStyle.width : 20}px;
            height: ${props => props.comparisonStyle?.checkBoxStyle ? props.comparisonStyle.checkBoxStyle.width : 20}px;
            border: 1px solid #999;
            background: #fff;

            &:hover {
                background: #418ded;
            }
            &.active {
                background: #418ded;

                &:before {
                    font-family: 'ppingkr_v4';
                    content: '';
                    color: #fff;
                    font-size: ${props => props.comparisonStyle?.checkBoxStyle ? props.comparisonStyle.checkBoxStyle.activeFontSize : 17}px;
                }
            }
        }
        .txt {
            margin: 0 0 0 7px;
            display: none;
            color: #418ded;
        }
        &:hover {
            border: 1px solid #ccc;
            background: #fff;
            width: 95px;
            ${props => props.comparisonStyle?.buttonHover ? props.comparisonStyle?.buttonHover : '' }


            .txt {
                display: block;
            }
        }
        &.active {
            .check {
                background: #418ded;

                &:before {
                    font-family: 'ppingkr_v4';
                    content: '\\e917';
                    color: #fff;
                    font-size: 15px;
                    width: 100%;
                    display: inline-block;
                    vertical-align: top;
                    margin: 2px 0 0;
                }
            }
        }
    }
`

export default ItemComparison



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_comparison.js